import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { getTableLang } from "../../Utils/Inits/getTableLang";
import { errorToast, goBackWithRefresh, successToast } from "../../Utils/utils";

export class TestEditor{
    abId:number;
    chooseWrapper:JQuery;
    chooseTable:JQuery<HTMLTableElement>;
    editWrapper:JQuery<HTMLElement>;
    editTable:JQuery<HTMLTableElement>;

    constructor() {
        this.abId = this.getAbId();
        this.chooseWrapper = $("#choose-tasks");
        this.chooseTable = this.chooseWrapper.find("table");

        this.editWrapper = $("#edit-ab");
        this.editTable = this.editWrapper.find("table");

        // init Tables
        this.initTables();
        // add Listeners
        this.initListeners();
    }

    getAbId(){
        return Number($("#test-id").val());
        // const urlParams = new URLSearchParams(window.location.search);
        // let abId = urlParams.get('as_id');
        // if (abId !== undefined && abId !== '' && abId !== null){
        //     return abId;
        // } else {
        //     return "0";
        // }
    }

    initTables(){
        this.initChooseTable();
        this.initEditTable();
    }

    initChooseTable(){
        // init sortable
        // this.chooseTable.find("tbody").sortable({
        //     group: 'list',
        //     animation: 200,
        //     ghostClass: 'ghost',
        //     onAdd: function(evt){
        //     }
        // });

        const zeilen = ['Aufgaben', 'Aufgabe']
        // init Datatable
        this.chooseData = this.chooseTable.DataTable({
            language: getTableLang({}, zeilen),
            dom: "<'row'<'col-sm-12 d-flex align-items-center justify-content-end'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-12'p>>",
            info: false,
            bLengthChange: false,
            paging: true,
            columnDefs: [
                {"orderable": false, "targets": [1]}
            ]
        });
    }

    initEditTable(){
        // init sortable
        this.editTable.find("tbody").sortable({
            group: 'list',
            animation: 200,
            ghostClass: 'ghost',
            onAdd: function(evt){
                //    console.log(evt); // hier dann converter einbauen!
            }
        });
        // init Datatable -> you do not need a dataTable for this!
        const change = {
            'emptyTable': 'Bitte füge eine Aufgabe hinzu'
        }
        const zeilen = ['Aufgaben', 'Aufgabe']
        this.editData = this.editTable.DataTable({
            language: getTableLang(change, zeilen),
            info: false,
            bLengthChange: false,
            ordering: false,
            searching: false,
            paging: false,
        });
    }

    initListeners(){
        const handler = this;
        // 1.
        this.chooseTable.on("click", ".add-task-to-ab", function(){
            const taskId = $(this).attr("data-aufgabe");
            const points = $(this).attr("data-punkte");
            const fachId = $(this).attr("data-fach");
            const fachNummer = $(this).attr("data-nummer");
            const btn = $(this);
            handler.addTaskToAb(taskId, points, btn, fachId, fachNummer);
        })
        // 2. Remove from edit-table and add to choose-table
        this.editTable.on("click", ".remove-task-from-ab", function(){
            const taskId = $(this).attr("data-aufgabe");

            const info = $(this).parent();
            const fachId = info.attr('data-fach');
            const fachNummer = info.attr('data-nummer');
            const btn = $(this);
            handler.removeTaskFromAb(taskId, btn, fachId, fachNummer);
        });
        // 2. Save AB
        this.editWrapper.on("click", ".save-ab", function(){
            handler.saveAb($(this));
        });
        // 4. On Change of input fields
        this.editWrapper.on("input", ".punkte", function(){
            const totalPoints = handler.calcTotalPoints();
            $("#gesamtpunkte").val(totalPoints);
        });
        this.editWrapper.on("blur", ".punkte", function(){
            const punkte = Number($(this).val());
            if (punkte <= 0 || punkte == '' || punkte == undefined){
                $(this).addClass("is-invalid");
            } else {
                $(this).removeClass("is-invalid");
            }
        });
        // 5. Remove all invalid classes
        this.editWrapper.on("input", ".ab-data", function(){
            if ($(this).hasClass("is-invalid")){
                $(this).removeClass("is-invalid");
            }
        });
        // 6. Add invalid class if left empty
        this.editWrapper.on("blur", ".ab-data", function(){
            const val = $(this).val();
            if (val == '' || val == undefined || Number(val) <= 0){
                $(this).addClass("is-invalid");
            }
        });
        this.editWrapper.on("click", ".edit-task", function(){
            const info = $(this).parent();
            const courseId = info.attr('data-aufgabe')
            window.open("/editor/" + courseId, "_blank");
        })
    }

    setTotalPoints(){
        const totalPoints = this.calcTotalPoints();
        $("#gesamtpunkte").val(totalPoints);
    }

    // Actions
    // add - to - ab
    addTaskToAb(taskId, points, button, fachId, fachNummer){
        const row = button.parent().parent();
        const name = row.find('.aufgabe-name').html();
        // remove row
        this.chooseData.row(row).remove().draw();
        // initRow
        this.initRowInAb(taskId, points, name, fachId, fachNummer);
    }

    initRowInAb(taskId, points, name, fachId, fachNummer){
        // TODO: Add task id and make beautiful -> and adjust
        const row = '<tr><td><i class="fas fa-arrows-alt handle"></i></td><td><a href="javascript:void(0);" class="aufgabe-name show-single-task" data-aufgabe="' + taskId +'">' + name + '</a></td><td><input type="text" value="'+points+'" class="punkte text-center form-control" pattern="^-?[0-9]+([,.][0-9]{1,4})?$"></td><td class="task-info" data-aufgabe="'+taskId+'" data-fach="'+fachId+'" data-nummer="'+fachNummer+'"><button type="button" class="btn btn-light-info text-info font-weight-medium waves-effect edit-task me-1" data-aufgabe="'+taskId+'"><i class="fa fa-edit"></i></button><button type="button" class="btn btn-light-danger text-danger font-weight-medium waves-effect remove-task-from-ab" data-aufgabe="'+taskId+'"><i class="fa fa-times-circle"></i></button></td></tr>';
        // this.editTable.find("tbody").append(row);
        this.editData.row.add($(row)).draw();
        this.setTotalPoints();
    }
    // remove - from - ab
    removeTaskFromAb(taskId, button, fachId, fachNummer){
        const row = button.parent().parent();
        const name = row.find(".aufgabe-name").html();
        const points = row.find(".punkte").val();
        // remove row from table
        this.editData.row(row).remove().draw();
        // add row again in choose-table on tob
        this.initRowInChoose(taskId, points, name, fachId, fachNummer);
        this.setTotalPoints();
    }

    initRowInChoose(taskId, points, name, fachId, fachNummer){
        const row = '<tr><td><a href="javascript:void(0);" class="aufgabe-name show-single-task" data-aufgabe="' + taskId + '">'+name+'</a></td><td><button type="button" class="add-task-to-ab btn waves-effect waves-light btn-rounded btn-outline-primary" data-aufgabe="'+taskId+'" data-punkte="'+points+'" data-fach="'+fachId+'" data-nummer="'+fachNummer+'">Einfügen</button></td></tr>';
        // this.chooseTable.find("tbody").prepend(row); // add at start
        this.chooseData.row.add($(row)).draw();
    }

    saveAb(btn){
        const info = this.getAbInfo();
        const validation = this.validate(info.name, info.minuten);
        if (validation.result) {

            const success = function(data){
                $(".save-ab").prop('disabled', true);
                successToast(data.message, 'Erfolg', 4500);
                setTimeout(function () {
                    goBackWithRefresh();
                }, 450);
            }

            const data = {
                'name': info.name,
                'minutes': info.minuten,
                'tasks': info.aufgaben,
            }

            const url = (this.abId == 0) ? '/test/create/' + $("#course-id").val() : '/test/' + this.abId.toString() + '/save';
            ajaxRequest(url, success, data, btn)

        } else {
            const felder = (validation.errors == 1) ? "Feld" : "Felder";
            errorToast('Speichern fehlgeschlagen', validation.errors + " " + felder + " fehlerhaft", 10000)
        }
    }

    calcTotalPoints(){
        let p = 0;
        const rows = this.editTable.find("tbody tr");
        rows.each(function(ind, obj){
            const punkte = Number($(obj).find(".punkte").val());
            p += punkte;
        });
        return p;
    }

    getAbInfo(){
        const rows = this.editTable.find("tbody tr");
        let output = {};
        const aufgaben = {};
        rows.each(function(ind, obj){
            const punkte = $(obj).find(".punkte").val();
            const taskId = $(obj).find(".task-info").attr("data-aufgabe");

            aufgaben[ind] = {
                "id": taskId,
                "points": punkte,
            }
        });
        const minuten = this.editWrapper.find("#minuten").val();
        const name = this.editWrapper.find("#ab-name").val();
        output = {
            "aufgaben": aufgaben,
            "minuten": minuten,
            "name": name
        }
        return output;
    }

    validate(name, minuten){
        let errors = 0;
        // 1. Name ?
        if (name == '' || minuten == undefined){
            errors += 1;
            $("#ab-name").addClass("is-invalid");
        }
        // 2. Minuten ?
        if (minuten <= 0 || minuten == '' || minuten == undefined){
            errors += 1;
            $("#minuten").addClass("is-invalid");
        }
        // 3. Punkte ?
        const rows = this.editTable.find("tbody tr");
        rows.each(function(ind, obj) {
            const punkteObj = $(obj).find(".punkte");
            const punkte = Number(punkteObj.val());
            if (punkte <= 0 || punkte == '' || punkte == undefined){
                errors += 1;
                punkteObj.addClass("is-invalid");
            }
        });
        const result = (errors != 0) ? false : true;
        return {
            "result": result,
            "errors": errors,
        }
    }
}